import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProjectRouteStationWithParam } from '../../shared/interfaces/project-route-station.class';
import { ProjectImageData } from '../../shared/interfaces/project-image-data.interface';
import { ProjectScenarioRouteStationModulComponent } from './project-scenario-route-station-modul/project-scenario-route-station-modul.component';
import { MatDialog } from '@angular/material/dialog';
import { DataEndChannel } from '../../shared/interfaces/data-end-channel.interface';
import { ManualControlService } from '../../shared/services/manual-control.service';
import { ScenarioControl } from '../../shared/interfaces/ScenarioControl.interface';
import { ScenarioService } from '../../shared/services/scenario.service';
import { ScenarioManual } from '../../shared/interfaces/scenario-manual';
import { environment } from 'src/environments/environment';
import { EditUser } from 'src/app/user/shared/interfaces/edit-user.interface';
import { Scenario } from '../../shared/interfaces/scenario.interface';
import { DataEndChannelTypeEnum } from '../../shared/enums/data-end-channel-type.enum';
import { getLaneLabel, getRadarTypeName } from '../../shared/functions/channel-label';

@Component({
  selector: 'avs-modular-route-station',
  templateUrl: './modular-route-station.component.html',
  styleUrls: ['./modular-route-station.component.css']
})
export class ModularRouteStationComponent implements OnInit {

  @Input() routeStation?: ProjectRouteStationWithParam;
  @Input() images?: ProjectImageData[] = [];
  @Input() projectId?: number;
  @Input() scenarioId?: number;
  @Input() scenarioManuals?: ScenarioManual[] = [];
  @Input() users?: EditUser[] = []
  @Output()
  myEvent = new EventEmitter<boolean>();
  @Output() updatedScenario = new EventEmitter<Scenario>();

  protected readonly environment = environment;
  public readonly DeType = DataEndChannelTypeEnum;

  /** Sensortyp eines RADAR-Kanals via Radar-Verknüpfung (Fallback „Sensor"). */
  public radarName(kanal: DataEndChannel): string {
    return getRadarTypeName(kanal, this.routeStation?.schemaInfo?.radars) ?? 'Sensor';
  }
  /** Fahrspur-Beschriftung aus der DE-Nummer. */
  public lane(kanal: DataEndChannel): string {
    return getLaneLabel(kanal.de);
  }

  constructor(private dialog: MatDialog,
    private manualControlService: ManualControlService,
    private scenarioService: ScenarioService
  ) { }

  public emitEvent() {
    this.myEvent.emit(true);
  }
  public ngOnInit(): void {
    if (this.scenarioManuals!.length > 0) {
      let scenarioManuals = this.scenarioManuals!.filter((x) => x.scenarioId === this.scenarioId)
      this.checkForManualControl(scenarioManuals);
    }
    this.sortBydeKanal(this.routeStation!.routeStation!.dataEndChannels!)
  }

  public sortBydeKanal(dataEndChannels: DataEndChannel[]) {
    dataEndChannels.sort(
      (a, b) => {
        // erst nach fg (Zahl)
        const fgDiff = a.fg - b.fg;
        if (fgDiff !== 0) {
          return fgDiff;
        }
        // dann nach de (Zahl)
        return a.de - b.de;
      }
    );
  }

  public getProperScenarioManual(kanalId: number): any {
    let response = this.scenarioManuals!.filter((x) => x.scenarioId === this.scenarioId && x.dataEndChannelId === kanalId)
    return response[0]
  }

  private checkForManualControl(scenarioManuals: ScenarioManual[]): void {
    scenarioManuals.forEach((scenarioManual) => {
      this.routeStation!.routeStation!.dataEndChannels?.forEach((dataEndChannel: DataEndChannel) => {
        if (dataEndChannel.id === scenarioManual.dataEndChannelId && scenarioManual.scenarioId === this.scenarioId) {
          dataEndChannel.scenarioControlObj = [];
          dataEndChannel.scenarioControlObj?.push({ scenarioId: scenarioManual.scenarioId, scenarioControl: scenarioManual.scenarioControl });
        }
      });
    })
  }

  public getPathByStellcodeId(stellcode: number) {
    if (this.images) {
      let imageObject = this.images.find((x) => x.stellcode == stellcode)
      return imageObject?.path as string
    }
    else return
  }

  public isBarrierChannel(kanal: DataEndChannel): boolean {
    return kanal.dataEndChannelType === DataEndChannelTypeEnum.LANESWITCH ||
      kanal.dataEndChannelType === DataEndChannelTypeEnum.BAR ||
      kanal.dataEndChannelType === DataEndChannelTypeEnum.SWING;
  }

  public getBarrierChannelName(kanal: DataEndChannel): string {
    switch (kanal.dataEndChannelType) {
      case DataEndChannelTypeEnum.LANESWITCH:
        return 'Weiche';
      case DataEndChannelTypeEnum.BAR:
        return 'Schranke';
      case DataEndChannelTypeEnum.SWING:
        return 'Drehschild';
      default:
        return 'Barrier';
    }
  }



  public onOpenComponentClicked(kanal: DataEndChannel) {
    let edit: boolean = false;
    let scenarioManual = this.getProperScenarioManual(kanal.id)
    if (scenarioManual !== undefined) edit = true;
    kanal.scenarioControlObj = scenarioManual
      ? [{ scenarioId: scenarioManual.scenarioId, scenarioControl: scenarioManual.scenarioControl }]
      : [];

    const dialogRef = this.dialog.open(ProjectScenarioRouteStationModulComponent, {
      disableClose: true,
      data: {
        kanal: kanal,
        routeStation: this.routeStation,
        projectId: this.projectId,
        scenarioId: this.scenarioId,
        scenarioManual: scenarioManual,
        edit: edit
      }
    })
    dialogRef.afterClosed().subscribe((result) => {
      if (result === "deleted") {
        this.scenarioService.removeManuelControlFromScenario(this.scenarioId!, scenarioManual.id).subscribe((res) => {
          this.scenarioService.getScenarioById(this.scenarioId!).subscribe((scenario) => {
            this.applyScenarioUpdate(scenario);
          });
        })
        return;
      }
      if (result === undefined) return;
      if (!edit) {
        this.manualControlService.createManualControl({ settings: result.settings, highPriority: result.highPriority }).subscribe((res: ScenarioControl) => { // res is die neu erstellte manualControl, die muss in das entsprechende scnearioManual rein
          this.scenarioService.addManualControlToScenario(this.scenarioId!, res.id!, kanal.id).subscribe((addResponse) => {
            addResponse.scenarioManuals?.map((x) => { x.scenarioControlId === res.id ? x.scenarioControl = res : x });
            this.applyScenarioUpdate(addResponse);
          });
        })
      }
      else {
        this.manualControlService.updateManualControl({ id: result.scenarioControlId, settings: result.settings, highPriority: result.highPriority }).subscribe(x => {
          this.scenarioService.getScenarioById(this.scenarioId!).subscribe((scenario) => {
            this.applyScenarioUpdate(scenario);
          });
        })
      }
    });
  }

  private applyScenarioUpdate(scenario: Scenario): void {
    this.scenarioManuals = scenario.scenarioManuals ?? [];
    this.updatedScenario.emit(scenario);
  }
}
